export default function injectLogger(klass) {
  const target = klass;
  target.prototype.logger = false;

  target.prototype.logLevel = 'debug';

  const log = function (values) {
    if (this.logLevel !== 'debug' && this.logLevel !== 'warn' && this.logLevel !== 'info') return;
    if (this.logger) {
      this.logger.log('Entitlements:', values);
    }
  };

  const warn = function (values) {
    if (this.logLevel !== 'debug' && this.logLevel !== 'warn') return;
    if (this.logger) {
      this.logger.warn('Entitlements:', values);
    }
  };

  const info = function (values) {
    if (this.logLevel !== 'info') return;
    if (this.logger) {
      this.logger.info('Entitlements:', values);
    }
  };

  target.prototype.log = log;
  target.prototype.warn = warn;
  target.prototype.info = info;
}
